import React from 'react';
import styled from 'styled-components';

import { Close } from '@mui/icons-material';
import { useTheme } from '../../styles/theme';
import { IconButton, TextField } from '@mui/material';
import { Buckets } from '@common/Autocomplete/Buckets';
import { TelnyxBucket } from '@requests/buckets';

export type Option = {
  id?: string;
  label: string;
  value: string;
  type?: 'telnyx' | 'weaviate';
};

interface BucketFieldProps {
  id: string;
  buckets: TelnyxBucket[];
  indexes: any[];
  bucketsLoading: boolean;
  index: string;
  weight: number;
  setIndex: (data: { value: string; field: 'index' | 'weight'; type: string }) => void;
  removeField: (value: string) => void;
}

const Container = styled.div`
  display: grid;
  grid-gap: 0.5rem;
  grid-template-columns: minmax(0, 8fr) 3fr 1fr;
  width: 100%;
`;

const Action = styled.div`
  display: flex;
  align-items: center;

  svg {
    font-size: 2ch;
  }
`;

export const BucketField: React.FC<BucketFieldProps> = ({
  indexes,
  buckets,
  bucketsLoading,
  id,
  index,
  weight,
  setIndex,
  removeField,
}) => {
  const theme = useTheme();

  const handleChange = (value: string): void => {
    if (!value) setIndex({ value: '', field: 'index', type: 'telnyx' });
    else setIndex({ value: value, field: 'index', type: 'telnyx' });
  };

  return (
    <Container>
      <Buckets
        value={index}
        loading={bucketsLoading}
        placeholder='Bucket'
        indexes={indexes}
        labels={buckets.map((bucket) => ({
          id: bucket.name,
          label: bucket.name,
          value: bucket.name,
        }))}
        onChange={(_, item: { value: string }) => {
          handleChange(item?.value || '');
        }}
      />
      <TextField
        size='small'
        fullWidth
        placeholder='Weight'
        label='Weight'
        value={weight || 1.0}
        sx={{ minWidth: '65px' }}
        type='number'
        onChange={(e) => {
          setIndex({
            value: e.target.value,
            field: 'weight',
            type: 'telnyx',
          });
        }}
      />
      <Action>
        <IconButton sx={{ border: `1px solid ${theme.line.light}`, padding: '6px' }} onClick={() => removeField(id)}>
          <Close sx={{ fontSize: '1.7ch !important' }} />
        </IconButton>
      </Action>
    </Container>
  );
};
